module.exports = __webpack_public_path__ + "static/media/congestion.d2e0bedf.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/congestion.png
// module id = 394
// module chunks = 0